import { v4 as uuid } from "uuid";
import { z } from "zod";
import { safeParse } from "../../../lib/zod";
import { ControlDefinition } from "../../definition";
import { DTOSchema, isRichTextDTO, richTextDTOtoDAO } from "../dto";
import { copyNodes } from "./copy";
import { introspectNodes } from "./introspection";
class Definition extends ControlDefinition {
  static type = "makeswift::controls::rich-text-v2";
  static Mode = {
    Inline: `${this.type}::mode::inline`,
    Block: `${this.type}::mode::block`
  };
  static get schema() {
    const type = z.literal(this.type);
    const version = z.literal(2);
    const dataV1 = DTOSchema.valueJSON;
    const dataV2 = z.object({
      type,
      version,
      descendants: z.array(z.any()),
      key: z.string()
    });
    const data = z.union([dataV1, dataV2]);
    const value = dataV2;
    const userConfig = z.object({
      mode: z.optional(
        z.union([z.literal(this.Mode.Inline), z.literal(this.Mode.Block)])
      ),
      defaultValue: z.optional(z.string())
    });
    return {
      type,
      data,
      dataV1,
      dataV2,
      value,
      userConfig
    };
  }
  get controlType() {
    return Definition.type;
  }
  get schema() {
    const baseSchema = Definition.schema;
    const definition = z.object({
      type: baseSchema.type,
      config: this.configSchema
    });
    return {
      ...baseSchema,
      definition,
      resolvedValue: this.nodeSchema
    };
  }
  get configSchema() {
    return z.any();
  }
  get nodeSchema() {
    return z.any();
  }
  safeParse(data) {
    return safeParse(this.schema.data, data);
  }
  fromData(data) {
    return data !== void 0 ? Definition.normalizeData(data) : void 0;
  }
  toData(value) {
    return value;
  }
  copyData(data, context) {
    if (data == null)
      return data;
    const nodes = Definition.dataToNodes(data);
    return Definition.nodesToDataV2(copyNodes(nodes, context));
  }
  introspect(data, target) {
    if (data == null)
      return [];
    const nodes = Definition.dataToNodes(data);
    return introspectNodes(nodes, target, this.pluginControls);
  }
  static isV1Data(data) {
    return isRichTextDTO(data);
  }
  static dataToNodes(data) {
    return Definition.isV1Data(data) ? richTextDTOtoDAO(data) : data.descendants;
  }
  static nodesToDataV2(descendants, key) {
    return {
      type: Definition.type,
      version: 2,
      descendants,
      key: key ?? uuid()
    };
  }
  static normalizeData(data) {
    return Definition.isV1Data(data) ? Definition.nodesToDataV2(richTextDTOtoDAO(data)) : data;
  }
}
export {
  Definition as RichTextDefinition
};
//# sourceMappingURL=rich-text.js.map